<div class="table-wrapper">
    <div>
        <aumico-button (click)="onCreateLegalFormPressed()">Add new Legal Form</aumico-button>
    </div>

    <aumico-settings-legal-form-list
        [data]="data"
        [languages]="languages"
        (editPressed)="editPressedEventHandler($event)"
    >
    </aumico-settings-legal-form-list>
</div>
